import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { TextArea } from 'telia-front-react';
import { MAX_DESCRIPTION_FIELD_LENGTH } from '../../stores/CallbackStore';

interface DescriptionFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

const DescriptionField = observer((props: DescriptionFieldProps): React.JSX.Element => {
  const { value, onChange, label } = props;
  const { translate } = React.useContext(TranslationsContext);

  const descriptionFieldHelper = (): string | undefined => {
    return value?.length === MAX_DESCRIPTION_FIELD_LENGTH
      ? (translate('form.fields.description.maxLength.notice', {
          maxLength: MAX_DESCRIPTION_FIELD_LENGTH
        }) as string)
      : undefined;
  };

  return (
    <TextArea
      id="description"
      label={label || translate('form.fields.description')}
      value={value}
      input={{ maxLength: MAX_DESCRIPTION_FIELD_LENGTH }}
      onChange={onChange}
      placeholderLabel={true}
      errorMessage={descriptionFieldHelper()}
    />
  );
});

export default DescriptionField;
